import { request } from '../utils/request';
import {
  ReportDocument,
  GetSystemUserDocument,
  GetAppConfigDocument,
  GetReportByPathDocument,
  GetReportByActionDocument,
  GetReportByActionFunnelDocument,
  GetPathListDocument,
  GetActionListDocument,
} from './operations';
import { print } from 'graphql';
import store from '../store';

export const VISUALIZATION_API_HOST = 'agency.woa.com';
const REPORT_API_BASE_PATH = 'https://e.qq.com/data-report-hub/api'; // '/data-report-hub/api';
const VISUALIZATION_API_BASE_PATH = `https://${VISUALIZATION_API_HOST}/data-report-hub/api`;

const getParams = (doc: any, variables?: any) => ({
  query: print(doc),
  variables: { params: variables || {} },
});

// 上报钩子函数
const beforeRequest = (variables: any) => {
  const reportUrl = store.config.reportUrl || REPORT_API_BASE_PATH;
  const reportData = variables;
  if (typeof store.config.beforeRequest === 'function') {
    return store.config.beforeRequest.call(null, { url: reportUrl, data: reportData });
  }
  return { url: reportUrl, data: reportData };
};

// 事件上报
export const report = (variables: any) => {
  const { url, data } = beforeRequest(variables);
  // 自定义上报函数
  if (typeof store.config.reportFunc === 'function') {
    return store.config.reportFunc.call(null, data)
      .then((res: any) => ({ report: res === true }));
  }
  // 自定义上报url
  if (store.config.reportUrl) {
    return request(url, data);
  }
  return request(url, getParams(ReportDocument, data));
};

export const reportSendBeacon = (variables: any) => {
  const { url, data } = beforeRequest(variables);
  // sendBeacon不支持自定义header，appId通过参数上传
  if (data) {
    data.data_report_app_id = store.appId;
    if (store.staffname) {
      data.data_report_staffname = store.staffname;
    }
  }
  const body = store.config.reportUrl ? data : getParams(ReportDocument, data);
  const headers = {
    type: 'application/json',
  };
  const blob = new Blob([JSON.stringify(body)], headers);
  return navigator.sendBeacon(url, blob);
};

// 获取系统用户信息
export const getSystemUser = () => request(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetSystemUserDocument),
);
// 获取系统配置
export const getAppConfig = () => request(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetAppConfigDocument),
);
// 获取页面埋点数据
export const getReportByPath = (variables: any) => request(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetReportByPathDocument, variables),
);
// 获取单个埋点详细数据
export const getReportByAction = (variables: any) => request(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetReportByActionDocument, variables),
);
// 获取漏斗数据
export const getReportByActionFunnel = (variables: any) => request(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetReportByActionFunnelDocument, variables),
);

// 获取路径列表
export const getPathList = (variables: any) => request(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetPathListDocument, variables),
);

// 获取事件列表
export const getActionList = (variables: any) => request(
  VISUALIZATION_API_BASE_PATH,
  getParams(GetActionListDocument, variables),
);
